<template>
	<el-card class="guest-container">
		<template #header>
		  <div class="header">
			  <el-button type="primary" size="small" icon="el-icon-plus" @click="editPoster('')">新增</el-button>
			  <el-button type="warning" size="small" icon="el-icon-plus" @click="updatePosterSort()">更新排序</el-button>
		  </div>
		</template>
		<el-table
		border highlight-current-row
		:header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据"
		v-loading="loading"
		:data="list"
		tooltip-effect="dark"
		style="width: 100%"
		>
			<el-table-column label="排序" prop="sort_order">
				<template v-slot="scope">
				    <el-input :style="{'width':'40%'}" type="text" v-model="scope.row.sort_order"></el-input>
				</template>
			</el-table-column>
			<el-table-column  label="图片链接">
				<template v-slot="scope">
					<el-image class="product-img-small" v-if="scope.row.image_url" :src="scope.row.image_url"
					 fit="contain" lazy>
					</el-image>
				</template>
			</el-table-column>
			<el-table-column prop="redirect_url" label="跳转链接"></el-table-column>
			<el-table-column prop="product_name" label="商品名"></el-table-column>
			<el-table-column prop="origin_price" label="原价"></el-table-column>
			<el-table-column prop="current_price" label="现价"></el-table-column>
			<el-table-column prop="more_url" label="more按钮url"></el-table-column>

			<el-table-column label="开始时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.start_time)}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间">
				<template v-slot="scope">
					{{timestampToTime(scope.row.end_time)}}
				</template>
			</el-table-column>
			<el-table-column
			  label="开启状态"
			>
			  <template #default="scope">
					<el-switch
						v-model="scope.row.status"
						active-color="#409EFF"
						inactive-color="#F56C6C"
						:active-value="1"
						:inactive-value="2"
						@change="changeEnabled(scope.row.status, scope.row.id)">
					</el-switch>
			  </template>
			</el-table-column>
			<el-table-column
			  label="操作"
			  width="auto"
			>
			  <template #default="scope">
						  <el-button type="primary" size="mini" @click="editPoster(scope.row)">编辑</el-button>
						  <el-button type="warning" size="mini" @click="delPoster(scope.row)">删除</el-button>
			  </template>
			</el-table-column>
		</el-table>
	</el-card>	
	<el-dialog title="商品" v-model="dialogFormVisible">
		<div class="col">
			<el-form  label-position="right" label-width="100px" :model="form" ref="form" :rules="rules">
				<el-form-item label="图片url" prop="image_url" >
					<el-input v-model="form.image_url" size="small" placeholder="图片url"></el-input>
				</el-form-item>
				<el-form-item label="跳转链接" prop="redirect_url">
					<el-input v-model="form.redirect_url" size="small" placeholder="跳转链接"></el-input>
				</el-form-item>
				<el-form-item label="商品名" prop="product_name">
					<el-input v-model="form.product_name" size="small" placeholder="商品名"></el-input>
				</el-form-item>
				<el-form-item label="原价" prop="origin_price">
					<el-input v-model="form.origin_price" size="small" placeholder="原价"></el-input>
				</el-form-item>
				<el-form-item label="现价" prop="current_price">
					<el-input v-model="form.current_price" size="small" placeholder="现价"></el-input>
				</el-form-item>
				<el-form-item label="more链接" prop="more_url">
					<el-input v-model="form.more_url" size="small" placeholder="more链接"></el-input>
				</el-form-item>
				<el-form-item label="开始时间" prop="start_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.start_time" type="date" placeholder="选择开始时间" autocomplete="off"></el-input>
					  </div>
				</el-form-item>
				<el-form-item label="结束时间" prop="end_time">
					<div class="block">
					    <el-input style="width: 220px;" v-model="form.end_time" type="date" placeholder="选择结束时间" autocomplete="off"></el-input>
					  </div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default{
		name: 'RakutenHomeRotation',
		components:{
		},
		data(){
			return{
				loading:true,
				list:[],
				dialogFormVisible:false,
				sort_orders_string:[],
				form:{
					image_url:'',
					redirect_url:'',
					product_name:'',
					origin_price:'',
					current_price:'',
					more_url:'',
					start_time:'',
					end_time:'',
					sort_order:0,
					
				},
				rules: {
					image_url: [{
						required: true,
						message: '请填写图片链接',
						trigger: 'blur'
					}],
					redirect_url: [{
						required: true,
						message: '请填写链接',
						trigger: 'blur'
					}],
						product_name: [{
						required: true,
						message: '请填写商品名',
						trigger: 'blur'
					}],
						origin_price: [{
						required: true,
						message: '请填写原价',
						trigger: 'blur'
					}],
						current_price: [{
						required: true,
						message: '请填写现价',
						trigger: 'blur'
					}],
						more_url: [{
						required: true,
						message: '请填写链接',
						trigger: 'blur'
					}],
					start_time:[{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time:[{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				},
			}
		},
		
		methods:{
			getPosterList(){
				this.httpPost({
					url:'/admin/rakuten/rakutenHotClothList',
					data: {
						routePath: this.$route.path
					}
				}).then((res)=>{
					this.loading=false;
					console.log(res);
					this.list=res.data;
				
				})
			},
			changeEnabled(status, id){
				let select_id = id;
				let change_status = status;
				if(select_id){
					this.loading=true;
					this.httpPost({
						url:'/admin/rakuten/rakutenHotClothStatus',
						data:{id:select_id,status:change_status}
					}).then((res)=>{
						if(res.code ==1){
							this.$message.success(res.msg);
							this.loading =false;
						}
					})
				}
			},
			editPoster(val){
				let temp = this.cloneObj(val);
				if (val) {
					temp.start_time = this.timestampToTime(temp.start_time);
					temp.end_time = this.timestampToTime(temp.end_time);
					this.form = temp;
				} else {
					this.resetObj(this.form);
				}
				
				this.dialogFormVisible=true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			delPoster(val){
				let id = val.id;
				this.msgBoxAjax(
				  '提示',
				  '确定删除吗？',
				  "/admin/rakuten/rakutenHotClothDelete",
				  {id:id}).then((res) => {
				  // console.log(data);
							
				  if (res.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							
				      this.getPosterList();
				    });
				  }else{
							
				    this.messageCommon('错误',res.msg,'error');
				  }		
				});
			},
			updatePosterSort(){
				let ids = [];
				this.sort_orders_string =[];
				this.$confirm('此操作将更新排序, 是否继续?', '提示', {
				                        confirmButtonText: '确定',
				                        cancelButtonText: '取消',
				                        type: 'warning'
				                    }).then((re) => {
				                        for (let i in this.list){
				                            if (this.sort_orders_string.indexOf(this.list[i].sort_order) == '-1'){
				                                //==-1表示该字符串不在此数组,返回值为-1
				                                this.sort_orders_string.push(this.list[i].sort_order);
				                                ids.push({id:this.list[i].id,sort_order:this.list[i].sort_order});
				                            }else{
				                                this.$message.error('排序有重复值');
				                                this.sort_orders_string = [];
				                                return;
				                            }
				                        }
										// console.log(ids);return;
										this.httpPost({
											url:'/admin/rakuten/rakutenHotClothSort',
											data:ids
										}).then((res)=>{
											if(res.code ==1){
												this.$message.success(res.msg);
												this.getPosterList();
											}
										})
				                    })
			},
			submit(){
				this.$refs['form'].validate((valid)=>{
					if(valid){
						this.updatePoster();
					}else{
						console.log('error submit!')
						return false;
					}
				})
				
			},
			updatePoster(){
				let id = this.form.id;
				if (!id) id = '';
				this.httpPost({
					url:'/admin/rakuten/rakutenHotClothUpdate?id='+ id,
					data:this.form
				}).then((res)=>{
					if(res.code ==1){
						this.dialogFormVisible = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getPosterList();
					}
				})
			}
		},
		created() {
			this.getPosterList();
		}
	}
</script>

<style>
</style>
